import defaultLogo from "src/assets/Logo2.svg?url";
import veiB4Logo from "src/assets/vei-b4.svg?url";

// Set to false to turn off per-URL distributor branding everywhere
// (logo + basename) and always fall back to the standard behavior.
const DISTRIBUTOR_BRANDING_ENABLED = true;

// Eagerly bundles every distributor logo so it can be picked at runtime
// based on the first URL segment, e.g. https://.../distributorName -> distributorName.png
const distributorLogoModules = import.meta.glob<string>(
  "/sipli-fleet-core/assets/distributor/*.{png,jpg,jpeg,svg}",
  { eager: true, import: "default" },
);

const distributorLogos: Record<string, string> = Object.fromEntries(
  Object.entries(distributorLogoModules).map(([path, url]) => [
    path.split("/").pop()!.replace(/\.(png|jpe?g|svg)$/i, "").toLowerCase(),
    url,
  ]),
);

export const getDistributorCode = (
  pathname: string = window.location.pathname,
): string | null => {
  if (!DISTRIBUTOR_BRANDING_ENABLED) return null;
  const segment = pathname.split("/").filter(Boolean)[0]?.toLowerCase();
  return segment && distributorLogos[segment] ? segment : null;
};

// The first URL segment doubles as the router basename when it matches a
// known distributor, so in-app navigation keeps e.g. /distributorName on every page.
export const getDistributorBasename = (): string => {
  const code = getDistributorCode();
  return code ? `/${code}` : "/";
};

export const getDistributorLogo = (fallback: string = defaultLogo): string => {
  const code = getDistributorCode();
  if (code === "vei") return veiB4Logo;
  return code ? (distributorLogos[code] ?? fallback) : fallback;
};

// Prefixes an absolute path with the current distributor basename, for the
// few spots that navigate via window.location instead of react-router.
export const withDistributorBasename = (path: string): string => {
  const basename = getDistributorBasename();
  if (basename === "/") return path;
  return path === "/" ? basename : `${basename}${path}`;
};
